import React from "react";
import BaseModal from "../../components/BaseModal";
import BaseButton from "../../components/BaseButton";
import { MODAL_TYPES } from "../../utils/emitter";
import { useTranslation } from "react-i18next";
import {useNavigate} from "react-router-dom";
import ROUTES from "../../utils/routes";
import Pricing from "../../store/Pricing";
import "./style.scss";

export default function BuyModal() {
  const navigate = useNavigate();

  const { t } = useTranslation();

  return (
    <BaseModal
      className="buy_game_modal little-mobile-modal"
      description={t("modals.buy_game.description")}
      eventTypeModal={MODAL_TYPES.BUY_GAME}
      descriptionStyle="buy_game__desc"
    >
      <BaseButton
        className="buy_game__button"
        onClick={() =>
          navigate(ROUTES.PAYMENT_PAGE)
        }
      >
        {/* кнопки покупки в попапах — без слова «Купить» (доработка 15.07);
           endgame_page.buyGame не трогаем — его использует страница описания анкеты.
           Pricing.format — единый формат цены во всех попапах («4900 ₽», как
           в BuyProductModal; getDomainPrice давал «4 900 ₽» с пробелом) */}
        {t("loyalty.buy_for", { price: Pricing.format("GAME") })}
      </BaseButton>
    </BaseModal>
  );
}
